import Phaser from "phaser";
import { data, finance, readyToOpen } from "../data";
import { createBg, moveBg } from "../modules/background";
import { createStone } from "../modules/createStone";
import { createAnimation } from "../modules/createAnimation";
import { createCharacter } from "../modules/createCharacter";
import { createCoins, createFreePlay } from "../modules/finance";
import { createPause, handlePauseMenu } from "../modules/pause";
import { jump, slide } from "../modules/actions";
import { createChest, moveChest, openChest } from "../modules/chest";
import { collisionEasy } from "../modules/lose";
import { createLine } from "../modules/createLine";
import { win, winFinalDialogue } from "../modules/win";
import { createTitle, updateTitle } from "../modules/title";
export default class Easy extends Phaser.Scene {
  width;
  height;
  scaleX;
  bg0;
  /** @type {Phaser.Physics.Arcade.Group} */
  bg1;
  /** @type {Phaser.Physics.Arcade.Group} */
  bg2;
  /** @type {Phaser.Physics.Arcade.Group} */
  bg3;
  /** @type {Phaser.Physics.Arcade.Group} */
  bg4;
  threshold;
  speedFactor;
  readyToJump;
  startSlide;
  frozen;
  stonesCreated;
  /** @type {Phaser.Physics.Arcade.Sprite} */
  character;
  title;
  /** @type {Phaser.Physics.Arcade.Sprite} */
  stone1;
  /** @type {Phaser.Physics.Arcade.Sprite} */
  stone2;
  /** @type {Phaser.GameObjects.Text} */
  coinsAmountText;
  isColliding;
  clickable;
  /** @type {Phaser.Physics.Arcade.Sprite} */
  line;
  /** @type {Phaser.Physics.Arcade.Sprite} */
  chest;
  chestOpenStarted;
  isOpenLoseWindow;
  chestRotatePos;
  chestRotateNeg;
  chestMoveUp;
  chestMoveDown;
  chestMoveUpLimit;
  chestMoveDownLimit;
  /** @type {Phaser.GameObjects.Image} */
  pause;
  isWon;
  constructor() {
    super("easy");
  }
  init() {
    this.scaleX = data().scaleX;
    this.width = this.sys.canvas.width;
    this.height = this.sys.canvas.height;
    this.bg0 = null;
    this.bg1 = null;
    this.bg2 = null;
    this.bg3 = null;
    this.bg4 = null;
    this.threshold = this.height - 20 * this.scaleX;
    this.speedFactor = 1;
    this.character = null;
    this.title = null;
    this.stone1 = null;
    this.stone2 = null;
    this.coinsAmountText = null;
    this.stonesCreated = 2;
    this.readyToJump = true;
    this.startSlide = true;
    this.frozen = false;
    this.isColliding = false;
    this.clickable = true;
    this.line = null;
    this.chest = null;
    this.chestOpenStarted = false;
    this.isOpenLoseWindow = true;
    this.chestRotatePos = true;
    this.chestRotateNeg = false;
    this.chestMoveUp = true;
    this.chestMoveDown = false;
    this.chestMoveUpLimit = 0;
    this.chestMoveDownLimit = 0;
    this.pause = null;
    this.isWon = false;
  }
  create() {
    if (finance.freePlay <= 0) {
      finance.skinned = false;
      this.scene.start("start");
    }
    [this.bg0, this.bg1, this.bg2, this.bg3, this.bg4] = createBg(
      this,
      this.width,
      this.height
    );
    createAnimation(this);
    this.character = createCharacter(this);
    this.title = createTitle(
      this,
      this.width,
      this.height,
      "Level 1",
      this.scaleX
    );
    this.coinsAmountText = createCoins(this, this.scaleX, this.width);
    createFreePlay(this, this.scaleX, this.width);
    this.pause = createPause(this, this.scaleX, () => {
      this.isOpenLoseWindow = false;
      this.pause.setVisible(false);
      this.frozen = true;
      this.clickable = false;
      this.character.setGravityY(0);
      this.character.setVelocityY(0);
      this.anims.pauseAll();
      handlePauseMenu(
        this,
        this.character,
        this.readyToJump,
        this.width,
        this.height,
        this.scaleX,
        () => {
          // this.sound.stopAll();
          this.scene.start("start");
          this.clickable = true;
        },
        () => {
          this.pause.setVisible(true);
          this.character.setGravityY(3000);
          this.stone1.setVelocityX(-450 * this.scaleX * this.speedFactor);
          this.stone2.setVelocityX(-450 * this.scaleX * this.speedFactor);
          this.anims.resumeAll();
          this.frozen = false;
          this.clickable = true;
        }
      );
    });
    this.addStones();
    this.line = createLine(this, this.threshold, this.character, () => {
      if (!finance.skinned) {
        this.character.play("run");
      } else {
        this.character.play("skinnedRun");
      }
      this.readyToJump = true;
      this.character.y = this.threshold;
      this.character.setVelocityY(0);
      this.character.setGravityY(0);
    });
    this.createEvents();
    this.chest = createChest(this, this.scaleX, this.width, this.height);
  }
  update(t, dt) {
    updateTitle(this.title, this.scaleX);
    if (!this.frozen) {
      moveBg(
        this,
        this.bg1,
        this.bg2,
        this.bg3,
        this.bg4,
        this.scaleX,
        this.width,
        1
      );
      if (this.threshold - this.character.y > 5) {
        this.readyToJump = false;
      }
      if (this.stone1 !== null && this.stone2 !== null) {
        if (this.stone1.x + this.stone1.body.width < 0) {
          this.stone1.setTexture(`stone${Phaser.Math.Between(0, 10)}`);
          this.stone1.x = this.width;
          this.stonesCreated++;
          if (this.stonesCreated > 10) {
            this.stone1.x = 0 - this.stone1.width;
          }
        }
        if (this.stone2.x + this.stone2.body.width < 0) {
          this.stone2.setTexture(`stone${Phaser.Math.Between(0, 10)}`);
          this.stone2.x = this.width;
          this.stonesCreated++;
          if (this.stonesCreated > 10) {
            this.stone2.x = 0 - this.stone2.width;
          }
        }
        if (!this.isWon) {
          if (
            this.stone1.x === 0 - this.stone1.width &&
            this.stone2.x === 0 - this.stone2.width
          ) {
            this.isWon = true;
            this.time.delayedCall(1000, () => {
              this.isOpenLoseWindow = false;
              this.frozen = true;
              this.clickable = false;
              win(
                this,
                this.character,
                this.pause,
                this.width,
                this.height,
                this.scaleX,
                () => {
                  finance.coins = finance.coins + 1;
                  this.coinsAmountText.text = finance.coins;
                },
                (levelComplete) => {
                  this.chestMoveUpLimit = 240 * this.scaleX;
                  this.chestMoveDownLimit = 290 * this.scaleX;
                  this.isOpenLoseWindow = true;
                  winFinalDialogue(
                    levelComplete,
                    this,
                    this.chest,
                    this.width,
                    this.height,
                    this.scaleX,
                    "medium"
                  );
                }
              );
            });
          }
        }
      }
    } else {
      this.bg1.setVelocityX(0);
      this.bg2.setVelocityX(0);
      this.bg3.setVelocityX(0);
      this.bg4.setVelocityX(0);
      if (
        this.isOpenLoseWindow &&
        !readyToOpen.value &&
        !this.chestOpenStarted
      ) {
        [
          this.chestRotatePos,
          this.chestRotateNeg,
          this.chestMoveUp,
          this.chestMoveDown,
        ] = moveChest(
          this.chestRotatePos,
          this.chestRotateNeg,
          this.chestMoveUp,
          this.chestMoveDown,
          this.chest,
          this.chestMoveUpLimit,
          this.chestMoveDownLimit,
          this.scaleX
        );
      }
      if (readyToOpen.value && !this.chestOpenStarted) {
        openChest(this, this.chest, this.width, this.scaleX);
        this.chestOpenStarted = true; // to make the block run only once
        readyToOpen.value = false; // to make this global variable ready to other levels
      }
      if (this.stone1 && this.stone2) {
        // to stop the stones from moving when the game is paused
        this.stone1.setVelocityX(0);
        this.stone2.setVelocityX(0);
      }
    }
  }
  createEvents() {
    const stopSlide = () => {
      this.startSlide = true;
      if (this.clickable) {
        if (!finance.skinned) {
          this.character.stop("slide").play("run");
        } else {
          this.character.stop("skinnedSlide").play("skinnedRun");
        }
      }
    };
    this.input.keyboard.on("keydown-SPACE", () => {
      jump(this, this.readyToJump, this.clickable, this.character, this.scaleX);
    });
    this.input.on("pointerdown", (e) => {
      if (e.x < this.width / 2) {
        if (this.startSlide) {
          slide(this.readyToJump, this.clickable, this.character);
        }
        this.startSlide = false;
      } else {
        jump(
          this,
          this.readyToJump,
          this.clickable,
          this.character,
          this.scaleX
        );
      }
    });
    this.input.on("pointerup", (e) => {
      if (e.x < this.width / 2) {
        stopSlide();
      }
    });
    this.input.keyboard.on("keydown-DOWN", () => {
      if (this.startSlide) {
        slide(this.readyToJump, this.clickable, this.character);
      }
      this.startSlide = false;
    });
    this.input.keyboard.on("keyup-DOWN", () => {
      stopSlide();
    });
  }
  addStones() {
    this.time.delayedCall(2000, () => {
      this.stone1 = createStone(
        this,
        this.width + 50,
        this.threshold,
        0,
        1,
        0.48 * this.scaleX,
        -450 * this.scaleX
      ).setVelocityX(-450 * this.scaleX * this.speedFactor);
      this.physics.add.collider(
        this.character,
        this.stone1,
        () => {
          this.chestMoveUpLimit = 290 * this.scaleX;
          this.chestMoveDownLimit = 330 * this.scaleX;
          this.isOpenLoseWindow = true;
          [this.isColliding, this.frozen, this.clickable] = collisionEasy(
            this,
            this.pause,
            this.isColliding,
            this.frozen,
            this.clickable,
            this.stone1,
            this.stone2,
            this.character,
            this.width,
            this.height,
            this.scaleX
          );
        },
        null,
        this
      );
      this.stone2 = createStone(
        this,
        this.width + 650 * this.scaleX,
        this.threshold,
        0,
        1,
        0.48 * this.scaleX,
        -450 * this.scaleX
      ).setVelocityX(-450 * this.scaleX * this.speedFactor);
      this.physics.add.collider(
        this.character,
        this.stone2,
        () => {
          this.chestMoveUpLimit = 290 * this.scaleX;
          this.chestMoveDownLimit = 330 * this.scaleX;
          this.isOpenLoseWindow = true;
          [this.isColliding, this.frozen, this.clickable] = collisionEasy(
            this,
            this.pause,
            this.isColliding,
            this.frozen,
            this.clickable,
            this.stone1,
            this.stone2,
            this.character,
            this.width,
            this.height,
            this.scaleX
          );
        },
        null,
        this
      );
    });
  }
}
